import store from '@/store';
import axios from 'axios';


const jc_pack_api = process.env.VUE_APP_JC_PACK_API;
const jc_auction_api = process.env.VUE_APP_JC_AUCTION_API;

async function getJcAuthHeader() {
  return {
    Authorization: `Bearer ${store.state.accessTokenJPC}`,
  }
}

async function axiosCall(endpoint:any = '', headers:any = {}, data:any = {}, method:any = 'GET') {
  return await axios({
    method: method,
    url: `${endpoint}`,
    params: data,
    headers: headers
  });
}

async function axiosJcPack(endpoint:any = '', data:any = {}, method:any = 'GET') {
  let url = `${jc_pack_api}/${endpoint}`;
  const headers = await getJcAuthHeader();
  let dataResult = await axiosCall(url, headers, data, method);
  if (dataResult.data.meta.code === '200') {
    return dataResult.data.data
  }
  throw new Error(`${endpoint}: failed`)
}

async function axiosJcAution(endpoint:any = '', data:any = {}, method:any = 'GET') {
  let url = `${jc_auction_api}/${endpoint}`;
  const headers = await getJcAuthHeader();
  let dataResult = await axiosCall(url, headers, data, method);
  if (dataResult.data.meta.code === '200') {
    return dataResult.data.data
  }
  throw new Error(`${endpoint}: failed`)
}


export async function getTransportVendors() {
  try {
    const endpoint = "api/admin/convert-kintone/transport-vendor"
    return await axiosJcPack(endpoint)
  } catch (error:any){
    return error.message
  }
}

export async function getYardVendors() {
  try {
    const endpoint = "api/admin/convert-kintone/yard-vendor"
    return await axiosJcPack(endpoint)
  } catch (error:any){
    return error.message
  }
}

export async function getAuctionVendors() {
  try {
    const endpoint = "api/admin/convert-kintone/auction-vendor"
    return await axiosJcAution(endpoint)
  } catch (error:any){
    return error.message
  }
}

export async function getTransportActualCosts(data:any) {
  try {
    const params = {
      auctionSiteId: null,
      satelliteId : null,
      yardArea: '',
      orderBy: data.orderBy,
      category:'',
      fromYardPlace: null,
      placeYardType:''
      
    };
    if(data.auctionSiteId !== undefined && data.yardArea !== undefined) {
      params.auctionSiteId = data.auctionSiteId;
      params.satelliteId = data.satelliteId;
      params.yardArea = data.yardArea;
      params.category = data.category;
      params.placeYardType = data.placeYardType;
      params.fromYardPlace = data.fromYardPlace;
    };
    const endpoint = "api/admin/convert-kintone/transport-actual-costs"
    return await axiosJcPack(endpoint, params)
  } catch (error:any){
    return error.message
  }
};

export async function getTransportCosts(data:any) {
  try {
    const params = {
      auctionSiteId: null,
      satelliteId : null,
      yardArea: '',
      customerId:'',
      category:'',
      fromYardPlace: null,
      placeYardType:''
    };
    if(data.auctionSiteId !== undefined && data.yardArea !== undefined) {
      params.auctionSiteId = data.auctionSiteId;
      params.satelliteId = data.satelliteId
      params.yardArea = data.yardArea;
      params.customerId = data.customerId;
      params.category = data.category;
      params.placeYardType = data.placeYardType;
      params.fromYardPlace = data.fromYardPlace;
    };
    const endpoint = "api/admin/convert-kintone/transport-costs"
    let records = await  axiosJcPack(endpoint, params)
    return records.map((r:any) =>
      [
        { field: '$id', key: 'id', type: 'int' },
        { field: 'AA_ID', key: 'auctionId', type: 'str' },
        { field: 'Yard_City', key: 'yardId', type: 'str' },
        { field: 'Base_Cost', key: 'base', type: 'int' },
        { field: 'Aplan', key: 'a', type: 'int' },
        { field: 'Bplan', key: 'b', type: 'int' },
        { field: 'Cplan', key: 'c', type: 'int' },
        { field: 'Dplan', key: 'd', type: 'int' },
        { field: 'Eplan', key: 'e', type: 'int' },
        { field: 'Fplan', key: 'f', type: 'int' },
      ].reduce((o: any, k) => {
        o[k.key] = k.type == 'int' ? +r[k.field].value : r[k.field].value;
        return o;
      }, {})
    );
  } catch (error:any){
    return error.message
  }
  
};

export async function getListHandlingCompany() {
  try {
    const endpoint = "api/admin/convert-kintone/handling-company"
    return await axiosJcPack(endpoint)
  } catch (error:any){
    return error.message
  }
}
